import { Trans, t } from "@lingui/macro";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Image, ImageBackground } from "react-native";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  Box,
  VStack,
  Text,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import { images } from "@whoosh/design-system/src/theme/images";

import { UnauthenticatedNavigatorParamList } from "../../navigators/UnauthenticatedStackNavigator/types";
import { UnauthenticatedRoutes } from "../../navigators/UnauthenticatedStackNavigator/unauthenticatedRoutes";

export const SSOErrorScreen = ({
  route,
  navigation,
}: NativeStackScreenProps<UnauthenticatedNavigatorParamList, "SSOError">) => {
  const params = route.params as
    | { phoneNumber?: string; clubLogoUrl?: string; message?: string }
    | undefined;

  return (
    <ImageBackground
      source={images.errorBackground}
      resizeMode="cover"
      style={{ flex: 1 }}
    >
      <HStack position="relative" flex={1} px={{ base: 0, lg: 8 }}>
        <Box width={{ base: 0, lg: "70%" }} flexShrink={1} flexGrow={0} />
        <VStack
          flexShrink={0}
          flexGrow={1}
          top={{ base: "50%", lg: 0 }}
          height={{ base: "50%", lg: "auto" }}
          width={{ base: "100%", lg: 460 }}
          mt={{ base: 0, lg: 8 }}
          mb={{ base: 0, lg: 6 }}
          backgroundColor="grayscale-0"
          borderTopLeftRadius="2"
          borderTopRightRadius="2"
          borderBottomLeftRadius={{ base: "0", lg: "2" }}
          borderBottomRightRadius={{ base: "0", lg: "2" }}
          px={8}
        >
          {params?.clubLogoUrl && (
            <Box
              alignItems="center"
              justifyContent="center"
              style={{ paddingTop: 86 }}
            >
              <Image
                source={{ uri: params.clubLogoUrl }}
                alt={t`Logo`}
                style={{ width: 120, height: 120 }}
              />
            </Box>
          )}
          <Box flex={1} alignItems="center">
            <Text
              maxFontSizeMultiplier={2}
              fontFamily="Times-Regular"
              fontSize={24}
              my={4}
            >
              {t`Login Error`}
            </Text>
            <Text
              maxFontSizeMultiplier={2}
              fontSize={16}
              fontWeight="500"
              my={4}
            >
              {params?.message
                ? params.message
                : params?.phoneNumber
                ? t`Please call the club at the number below for assistance`
                : t`Please contact the club for assistance.`}
            </Text>

            <Text
              maxFontSizeMultiplier={2}
              my={4}
              fontSize={16}
              style={{ borderBottomWidth: 1 }}
              fontWeight="bold"
              lineHeight={16}
            >
              {params?.phoneNumber}
            </Text>

            <Button
              style={{ marginVertical: 16 }}
              variant="secondary"
              accessibilityLabel={t`Return To Previous Page`}
              onPress={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack();
                } else {
                  navigation.navigate(UnauthenticatedRoutes.Initial as never);
                }
              }}
            >
              <Text
                maxFontSizeMultiplier={2}
                fontWeight="bold"
                fontSize={16}
                color="black"
              >
                {t`Return To Previous Page`}
              </Text>
            </Button>
          </Box>
          <HStack py={12}>
            <Text
              maxFontSizeMultiplier={2}
              color="grayscale-800"
              fontWeight="600"
            >
              <Trans>Have an account?</Trans>
            </Text>
            <Button
              onPress={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack();
                } else {
                  navigation.navigate(UnauthenticatedRoutes.Initial as never);
                }
              }}
              variant="secondary"
              accessibilityLabel={t`Sign In`}
            >
              <Text
                maxFontSizeMultiplier={2}
                fontSize={16}
                color="main-primary-500"
                fontWeight="bold"
              >
                <Trans>Sign In</Trans>
              </Text>
            </Button>
          </HStack>
        </VStack>
      </HStack>
    </ImageBackground>
  );
};
